// extracted by mini-css-extract-plugin
export default {"rating":"yD-z","numberOfStars":"zD-z","count":"AD-z","barGraphSpacing":"BD-z","barGraph":"CD-z"};